import { DsaUser } from '../../../services/dsa-users/dsa-user.model';

const dsaUsers: DsaUser[] = [
  {
    iamId: 'iam-dsa-001',
    firstName: 'Dana',
    lastName: 'Sauer',
    email: 'dana.sauer@dataspace-authority.test',
    enabled: true
  },
  {
    iamId: 'iam-dsa-005',
    firstName: 'Sven',
    lastName: 'Adler',
    email: 'sven.adler@dataspace-authority.test',
    enabled: true
  }
];

export function getDsaUsers(): DsaUser[] {
  return [...dsaUsers];
}

export function addDsaUser(user: DsaUser): DsaUser {
  const created: DsaUser = {
    iamId: `iam-dsa-${String(Date.now()).slice(-6)}`,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    enabled: true
  };
  dsaUsers.push(created);
  return created;
}

export function updateDsaUser(iamId: string, user: DsaUser): DsaUser | null {
  const existing = dsaUsers.find((u) => u.iamId === iamId);
  if (!existing) {
    return null;
  }
  existing.firstName = user.firstName;
  existing.lastName = user.lastName;
  existing.email = user.email;
  return { ...existing };
}

export function setDsaUserEnabled(iamId: string, enabled: boolean): boolean {
  const user = dsaUsers.find((u) => u.iamId === iamId);
  if (!user) {
    return false;
  }
  user.enabled = enabled;
  return true;
}

export function deleteDsaUser(iamId: string): boolean {
  const index = dsaUsers.findIndex((u) => u.iamId === iamId);
  if (index === -1) {
    return false;
  }
  dsaUsers.splice(index, 1);
  return true;
}
